// extracted by mini-css-extract-plugin
export default {"formItem":"DataPolicyCheck_formItem__sqe2C"};